import { createSlice } from '@reduxjs/toolkit';

import reducers from './reducers';
import { initialInvestigationsState } from './state';

export const investigationsSlice = createSlice({
  initialState: initialInvestigationsState,
  name: 'investigations',
  reducers,
});

export const {
  mergeAlertManualReview,
  mergeInvestigationsQueue,
  mergeInvestigationsQueuePagination,
  mergeInvestigationsQueueFilters,
  mergeInvestigationQueueTagsOutcomeReasons,
  mergeInvestigationsQueueSavedSearches,
  mergeInvestigation,
  mergeInvestigationsQueueError,
  mergeAssignableAgents,
  mergeAssignedAgent,
  mergeAlertAssignedAgent,
  mergeAlertUnassignedAgent,
  mergeInvestigationViewError,
  mergeInvestigationFetched,
  mergeInvestigationReviewsByToken,
  mergeInvestigationSummary,
  mergeInvestigationEvidence,
  mergeJourneyAlert,
  mergeJourneyAlertAssignableAgents,
  mergeSecondaryInvestigationData,
  mergeTimelineItems,
  mergeUnassignInvestigationAgent,
  resetInvestigationState,
  mergeArchivedInvestigation,
  mergeWebhookAuditEventDetails,
} = investigationsSlice.actions;

export default investigationsSlice.reducer;
